import { FileFieldMulti, FileFieldMultiProps } from '@components/file-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFileFieldMultiProps<T> = FormFieldProps<FileFieldMultiProps, T>;

export function FormFileFieldMulti<T>(props: FormFileFieldMultiProps<T>) {
  const formFieldProps = useFormField(props);

  return <FileFieldMulti {...props} {...formFieldProps} />;
}
